import { ModuleWithProviders, NgModule } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NModuleGtm } from './df-module-gtm.interfaces';
import { GtmEventAddPaymentInfoTrigger } from './event/add-payment-info/gtm-event-add-payment-info.trigger';
import { GtmEventAddShippingInfoTrigger } from './event/add-shipping-info/gtm-event-add-shipping-info.trigger';
import { GtmEventAddToCartTrigger } from './event/add-to-cart/gtm-event-add-to-cart.trigger';
import { GtmEventAddToWishlistTrigger } from './event/add-to-wishlist/gtm-event-add-to-wishlist.trigger';
import { GtmEventBasketUpdateTrigger } from './event/basket-update/gtm-event-basket-update.trigger';
import { GtmEventBeginCheckoutTrigger } from './event/begin-checkout/gtm-event-begin-checkout.trigger';
import { GtmEventContentViewTrigger } from './event/content-view/gtm-event-content-view.trigger';
import { GtmEventCustomTrigger } from './event/custom/gtm-event-custom.trigger';
import { GtmEventCustomerDataTrigger } from './event/customer-data/gtm-event-customer-data.trigger';
import { GtmEventLoginTrigger } from './event/login/gtm-event-login.trigger';
import { GtmEventProvideEmailTrigger } from './event/provided-email/gtm-event-provide-email.trigger';
import { GtmEventPurchaseTrigger } from './event/purchase/gtm-event-purchase.trigger';
import { GtmEventRemoveFromCartTrigger } from './event/remove_from_cart/gtm-event-remove-from-cart.trigger';
import { GtmEventSearchTrigger } from './event/search/gtm-event-search.trigger';
import { GtmEventSelectItemTrigger } from './event/select-item/gtm-event-select-item.trigger';
import { GtmEventSignupTrigger } from './event/signup/gtm-event-signup.trigger';
import { GtmEventTierCookieConsentChangeTrigger } from './event/tier-cookie-consent-change/gtm-event-tier-cookie-consent-change.trigger';
import { GtmEventViewCartTrigger } from './event/view-cart/gtm-event-view-cart.trigger';
import { GtmEventViewItemListTrigger } from './event/view-item-list/gtm-event-view-item-list.trigger';
import { GtmEventViewItemTrigger } from './event/view-item/gtm-event-view-item.trigger';
import { GtmCategoryToListPipe } from './integration/gtm-category-to-list.pipe';
import { GtmContentLinksTrackDirective } from './integration/gtm-content-links-track.directive';
import './integration/gtm-inclusion';
import { GtmItemLinkDirective } from './integration/gtm-item-link.directive';
import { GtmItemDirective } from './integration/gtm-item.directive';
import { GtmListDirective } from './integration/gtm-list.directive';
import { GtmPromotionLinkDirective } from './integration/gtm-promotion-link.directive';

/**
 * This GTM module is for tracking events in Google Tag Manager.
 * It use Google Analytics 4 data layer.
 */
@NgModule({
    imports: [
        GtmCategoryToListPipe,
        GtmItemDirective,
        GtmItemLinkDirective,
        GtmListDirective,
        GtmPromotionLinkDirective,
        GtmContentLinksTrackDirective
    ],
    exports: [
        GtmCategoryToListPipe,
        GtmItemDirective,
        GtmItemLinkDirective,
        GtmListDirective,
        GtmPromotionLinkDirective,
        GtmContentLinksTrackDirective
    ]
})
export class DfModuleGtmModule {
    static forRoot(config?: DeepPartial<NModuleGtm.IModuleOptions>): ModuleWithProviders<DfModuleGtmModule> {
        return {
            ngModule: DfModuleGtmModule,
            providers: [
                {
                    provide: NModuleGtm.OPTIONS,
                    useFactory: () => {
                        if (typeof window !== 'undefined') {
                            if (window.dataLayer === undefined) {
                                window.dataLayer = [];
                            }
                        }
                        return defaultsDeep(config || {}, <NModuleGtm.IModuleOptions>{
                            customerFields: ['logged', 'id', 'mage_store', 'group_id', 'email', 'newsletter'],
                            view: {
                                mode: 'viewport'
                            },
                            includeTax: true
                        });
                    }
                }
            ]
        };
    }

    constructor(
        e1: GtmEventAddToCartTrigger,
        e2: GtmEventAddToWishlistTrigger,
        e3: GtmEventAddPaymentInfoTrigger,
        e4: GtmEventAddShippingInfoTrigger,
        e5: GtmEventBasketUpdateTrigger,
        e6: GtmEventBeginCheckoutTrigger,
        e7: GtmEventContentViewTrigger,
        e8: GtmEventCustomTrigger,
        e9: GtmEventCustomerDataTrigger,
        e10: GtmEventLoginTrigger,
        e11: GtmEventPurchaseTrigger,
        e12: GtmEventRemoveFromCartTrigger,
        e13: GtmEventSearchTrigger,
        e14: GtmEventSignupTrigger,
        e15: GtmEventSelectItemTrigger,
        e16: GtmEventTierCookieConsentChangeTrigger,
        e17: GtmEventViewCartTrigger,
        e18: GtmEventViewItemListTrigger,
        e19: GtmEventViewItemTrigger,
        e20: GtmEventProvideEmailTrigger
    ) {}
}
